import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import "./Navbar.css";
import { IconContext } from "react-icons/lib";



function Navbar() {
  const [click, setClick] = useState(false);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);
  return (
    <>
      <IconContext.Provider value={{ color: "#E31937" }}>
        <div className= " navbar">
          <div className="navbar-container container">
            <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
              <img
                src={process.env.PUBLIC_URL + "/CGI_logo_color_rgb.png"}
                width="20%"
                alt="Logo"
              />
              <h4 className="Logo--text">SCE Sustainability Week  </h4>
            </Link>
            <div className="menu-icon" onClick={handleClick}>
              {click ? <FaTimes /> : <FaBars />}
            </div>
            <ul className={click ? "nav-menu active" : "nav-menu"}>
              <li className="nav-item">
                <Link
                  to="/home"
                  className="nav-links"
                  onClick={closeMobileMenu}
                >
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/program"
                  className="nav-links"
                  onClick={closeMobileMenu}
                >
                  Program
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/infoLog"
                  className="nav-links"
                  onClick={closeMobileMenu}
                >
                  Info Log
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/faq" className="nav-links" onClick={closeMobileMenu}>
                  FAQ
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/pastActivities"
                  className="nav-links"
                  onClick={closeMobileMenu}
                >
                  Past Activities
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/contact"
                  className="nav-links"
                  onClick={closeMobileMenu}
                >
                  Contacts
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </IconContext.Provider>
    </>
  );
}

export default Navbar;
